import React from "react";
import { Link } from "react-router-dom";
import { ELCID, IMediaToolkitNavPage } from "../models/IMediaToolkit";

export interface ILandingPageProps extends IMediaToolkitNavPage {
    createTitle: string;
    createDescription: string;
    tutorialTitle: string;
    tutorialDescription: string;
    guestPlanFirstPage?: string;
}

export const LandingPage: React.FunctionComponent<ILandingPageProps> = (props) => {
    return (
        <>
            <div className="card-header  bg-aap-creamy-gray-500 text-aap-red-700 px-5 xl:px-10 py-5 pt-10">
                <div>
                    <h1 className="text-5xl mb-5">{props.title}</h1>
                    <div className="text-sm" dangerouslySetInnerHTML={{ __html: props.description }}></div>
                </div>
            </div>
            <div className="card-body bg-aap-cream-500 p-5 xl:p-10">
                <div className="lg:px-10 lg:flex">
                    {props.readonly ? (
                        <div className="mx-auto lg:px-5 my-10 lg:my-0 lg:w-1/2 max-w-xl text-center">
                            <Link
                                to={"/finish"}
                                className="bg-aap-orange-500 hover:bg-aap-orange-600 py-3 px-5 mb-3 rounded text-white w-full block"
                                id={`btn_directToFinish_${ELCID[props.lcid]}`}
                            >
                                View media plan
                            </Link>
                        </div>
                    ) : (
                        <>
                            <div className="mx-auto lg:px-5 my-10 lg:my-0 lg:w-1/2 max-w-xl text-center">
                                <Link
                                    to="/family"
                                    className="bg-aap-orange-500 hover:bg-aap-orange-600 py-3 px-5 mb-3 rounded text-white w-full block"
                                    id={`btn_start_createMediaPlan_${ELCID[props.lcid]}`}
                                >
                                    {props.createTitle}
                                </Link>
                                <p className="px-2" dangerouslySetInnerHTML={{ __html: props.createDescription }}></p>
                            </div>
                            <div className="mx-auto lg:px-5 my-10 lg:my-0 lg:w-1/2 max-w-xl text-center">
                                <Link
                                    to="/tutorial"
                                    className="bg-aap-green-500 hover:bg-aap-green-600 py-3 px-5 mb-3 rounded text-white w-full block"
                                    id={`btn_start_tutorial_${ELCID[props.lcid]}`}
                                >
                                    {props.tutorialTitle}
                                </Link>
                                <p className="px-2" dangerouslySetInnerHTML={{ __html: props.tutorialDescription }}></p>
                            </div>
                        </>
                    )}
                </div>
                {props.footer ? (
                    <div className="pt-10">
                        <div dangerouslySetInnerHTML={{ __html: props.footer || "" }}></div>
                    </div>
                ) : null}
            </div>
        </>
    );
};
